import { ServicesService } from './../../../services/services/servicesService';
import { AddQuestionComponent } from './../add-question/add-question.component';

import { Component, OnInit, Input } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { UpdateQuestionComponent } from '../update/update-question.component';
import { QuestionsService } from '../../services/questionsService';

@Component({
  selector: 'ngx-service-questions',
  templateUrl: './service-question.component.html',
  styleUrls: ['./service-question.component.scss'],
})
export class ServiceQuestionComponent implements OnInit {
  @Input() servicesQuestions: any[];
  @Input() servicesId;

  constructor(private diag: NbDialogService, private service: ServicesService, private toast: NbToastrService,
    private qservice: QuestionsService,
    ) {}

  ngOnInit() {}

  addversion() {
    this.diag.open(AddQuestionComponent, { context: { serviceId: this.servicesId } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.service.getById(this.servicesId).subscribe((resp) => {
          this.servicesQuestions = resp.questions;
        });
      }
    });
  }

  update(question) {
    this.diag.open(UpdateQuestionComponent, { context: { question: question } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.service.getById(this.servicesId).subscribe((resp) => {
          this.servicesQuestions = resp.questions;
        });
      }
    });
  }
  delete(id) {
    this.qservice.delete(id).subscribe((res) => {
      this.toast.show('تم حذف السؤال بنجاح', '', { status: 'success', duration: 3000 });

      this.service.getById(this.servicesId).subscribe((resp) => {
        this.servicesQuestions = resp.questions;
      });
    });
  }
}
